"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Fields_1 = require("Common/Form/Fields");
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var PersonalDetails_1 = require("./PersonalDetails/PersonalDetails");
var BrandFetchDetails_1 = require("@CommonFrontendBackend/Account/Brand/BrandFetchDetails");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var IsPersonalEmail_1 = __importDefault(require("@CommonFrontendBackend/Utils/IsPersonalEmail"));
var CensusCollectorStore = (function () {
    function CensusCollectorStore(user, account, userListLength) {
        var _this = this;
        this.user = user;
        this.account = account;
        this.userListLength = userListLength;
        this.formFields = {};
        this.reactionDisposers = [];
        this.deleteColor = function (index) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                this.brandDetails.colors.splice(index, 1);
                return [2];
            });
        }); };
        this.updateColor = function (newColor, index) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                this.brandDetails.colors[index] = (0, ColorUtils_1.getHex)(newColor);
                return [2];
            });
        }); };
        this.registerTriggerPulse = function (triggerPulse) {
            _this.reactionDisposers = [
                (0, mobx_1.reaction)(function () { return _this.userName; }, function () { return triggerPulse(); }),
                (0, mobx_1.reaction)(function () { return _this.getById(Fields_1.Password.id); }, function () { return triggerPulse(); }),
                (0, mobx_1.reaction)(function () { return _this.companyName; }, function () { return triggerPulse(); }),
                (0, mobx_1.reaction)(function () { return _this.salesTeamSize; }, function () { return triggerPulse(2.5); }),
                (0, mobx_1.reaction)(function () { return _this.getById(PersonalDetails_1.crmInUse.id); }, function () { return triggerPulse(3); }),
                (0, mobx_1.reaction)(function () { return _this.getById(PersonalDetails_1.userRoleField.id); }, function () { return triggerPulse(3); }),
            ];
        };
        this.unregisterTriggerPulse = function () {
            _this.reactionDisposers.forEach(function (dispose) { return dispose(); });
        };
        if (user.firstName) {
            var fullName = (0, GetFullName_1.default)({
                firstName: user.firstName,
                lastName: user.lastName,
            });
            this.setById(Fields_1.Name.id, fullName);
        }
        if (userListLength === 1) {
            if (account.phoneNumber) {
                this.setById(Fields_1.PhoneNumber.id, account.phoneNumber);
            }
            if (account.name != "Account Name") {
                this.setById(Fields_1.CompanyName.id, account.name);
            }
        }
        this.brandDetails = __assign(__assign({}, BrandFetchDetails_1.defaultBrandFetchDetails), { websiteUrl: "", qwilrSubdomain: { value: "" } });
    }
    CensusCollectorStore.prototype.getById = function (id) {
        return this.formFields[id] || "";
    };
    CensusCollectorStore.prototype.setById = function (id, value) {
        this.formFields[id] = value;
    };
    CensusCollectorStore.prototype.update = function (newValues) {
        this.formFields = __assign(__assign({}, this.formFields), newValues);
    };
    Object.defineProperty(CensusCollectorStore.prototype, "userName", {
        get: function () {
            return this.getById(Fields_1.Name.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "companyName", {
        get: function () {
            return this.getById(Fields_1.CompanyName.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "companySize", {
        get: function () {
            return this.getById(Fields_1.OptionGroupCompanySize.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "salesTeamSize", {
        get: function () {
            return this.getById(Fields_1.OptionGroupSalesTeamSize.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "colors", {
        get: function () {
            return this.brandDetails.colors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "websiteUrl", {
        get: function () {
            return this.brandDetails.websiteUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "qwilrSubdomain", {
        get: function () {
            return this.brandDetails.qwilrSubdomain.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "companyDomain", {
        get: function () {
            return this.brandDetails.domain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "brandDetailsState", {
        get: function () {
            return this.brandDetails.state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "brandDetailsName", {
        get: function () {
            return this.brandDetails.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "logoUrls", {
        get: function () {
            return this.brandDetails.logos;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "brandDetailsError", {
        get: function () {
            if (this.brandDetails.logos.length === 0) {
                return "Please add a logo";
            }
            if (this.brandDetails.colors.length === 0) {
                return "Please add a color";
            }
            if (!this.brandDetails.qwilrSubdomain.value) {
                return "Please name your Qwilr subdomain";
            }
            if (this.brandDetails.qwilrSubdomain.errorMessage) {
                return "Please fix your Qwilr subdomain";
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "isBrandDetailsEmpty", {
        get: function () {
            return (this.brandDetails.logos.length === 0 &&
                this.brandDetails.colors.length === 0 &&
                this.brandDetails.qwilrSubdomain.value === "");
        },
        enumerable: false,
        configurable: true
    });
    CensusCollectorStore.prototype.addColor = function (color) {
        this.brandDetails.colors.push((0, ColorUtils_1.getHex)(color));
    };
    CensusCollectorStore.prototype.setWebsiteUrl = function (url) {
        this.brandDetails.websiteUrl = url;
    };
    CensusCollectorStore.prototype.setQwilrSubdomain = function (subdomain) {
        this.brandDetails.qwilrSubdomain.value = subdomain;
    };
    CensusCollectorStore.prototype.setSubdomainError = function (errMessage) {
        this.brandDetails.qwilrSubdomain.errorMessage = errMessage;
    };
    CensusCollectorStore.prototype.deleteLogo = function (index) {
        this.brandDetails.logos.splice(index, 1);
    };
    CensusCollectorStore.prototype.addLogo = function (url) {
        this.brandDetails.logos.splice(0, 0, url);
    };
    CensusCollectorStore.prototype.updateSuggestedSubdomain = function (accountName) {
        this.brandDetails.qwilrSubdomain.value = this.deriveSubdomainFromName(accountName);
    };
    CensusCollectorStore.prototype.updateBrandDetails = function (fetchData, websiteUrl, accountName) {
        this.brandDetails = __assign(__assign({}, fetchData), { websiteUrl: websiteUrl !== null && websiteUrl !== void 0 ? websiteUrl : "", qwilrSubdomain: {
                value: fetchData.state === BrandFetchDetails_1.BrandFetchState.Empty ? "" : this.deriveSubdomainFromName(accountName !== null && accountName !== void 0 ? accountName : fetchData.name),
            } });
    };
    CensusCollectorStore.prototype.resetBrandDetails = function () {
        this.updateBrandDetails(BrandFetchDetails_1.defaultBrandFetchDetails);
    };
    CensusCollectorStore.prototype.shouldFetchBrandDetails = function () {
        return !(0, IsPersonalEmail_1.default)(this.user.email);
    };
    CensusCollectorStore.prototype.deriveSubdomainFromName = function (name) {
        if (!name) {
            return "";
        }
        return name.replace(/[^A-Za-z0-9]/g, "").toLowerCase();
    };
    var _a, _b, _c, _d;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof kaleidoscope_1.IFormValues !== "undefined" && kaleidoscope_1.IFormValues) === "function" ? _a : Object)
    ], CensusCollectorStore.prototype, "formFields", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], CensusCollectorStore.prototype, "brandDetails", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "setById", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof kaleidoscope_1.IFormValues !== "undefined" && kaleidoscope_1.IFormValues) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "update", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "userName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "companyName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "companySize", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "salesTeamSize", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "colors", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "websiteUrl", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "qwilrSubdomain", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "companyDomain", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof BrandFetchDetails_1.BrandFetchState !== "undefined" && BrandFetchDetails_1.BrandFetchState) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "brandDetailsState", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "brandDetailsName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "logoUrls", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "brandDetailsError", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "isBrandDetailsEmpty", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "addColor", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CensusCollectorStore.prototype, "deleteColor", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], CensusCollectorStore.prototype, "updateColor", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "setWebsiteUrl", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "setQwilrSubdomain", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "setSubdomainError", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "deleteLogo", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "addLogo", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "updateSuggestedSubdomain", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof BrandFetchDetails_1.BrandFetchDetails !== "undefined" && BrandFetchDetails_1.BrandFetchDetails) === "function" ? _d : Object, String, String]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "updateBrandDetails", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "resetBrandDetails", null);
    return CensusCollectorStore;
}());
exports.default = CensusCollectorStore;
